import { makeStyles, alpha } from '@material-ui/core/styles';
// Shared design tokens; they move into the app theme with the homepage's.
import { eyebrowStyle, icon, text } from '@univerus/plugin-products';

export const useAskAiStyles = makeStyles(theme => ({
  // The floating Ask AI button, bottom right on every page.
  launcher: {
    position: 'fixed',
    right: 24,
    bottom: 24,
    zIndex: theme.zIndex.speedDial,
    textTransform: 'none',
    fontSize: text.small,
    fontWeight: 600,
    '& svg': { fontSize: icon.small, marginRight: 8 },
    // Clear of the bottom navigation bar on phones.
    [theme.breakpoints.down('xs')]: { right: 16, bottom: 80 },
  },
  drawer: {
    width: 440,
    maxWidth: '100%',
    padding: 28,
    boxSizing: 'border-box',
    gap: 20,
  },
  head: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'space-between',
    gap: 8,
  },
  // Small-capitals label naming the drawer; the large title follows it.
  label: eyebrowStyle(theme),
  title: {
    fontSize: text.stat,
    fontWeight: 600,
    lineHeight: '34px',
    letterSpacing: '-.6px',
  },
  description: {
    color: theme.palette.text.secondary,
    margin: '0 0 4px',
    fontSize: text.body,
    lineHeight: '22px',
  },
  status: {
    borderLeft: `3px solid ${theme.palette.primary.main}`,
    background: alpha(theme.palette.primary.main, 0.08),
    padding: 16,
    fontSize: text.small,
    lineHeight: '20px',
    '& p': { margin: '6px 0 0' },
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
  },
  suggestions: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 8,
    '& button': { fontSize: text.meta, textTransform: 'none' },
  },
  // The codebase conversation: one flat block per turn, divided by rules.
  conversation: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
  },
  turn: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    padding: '16px 0',
    borderTop: `1px solid ${theme.palette.divider}`,
    '&:first-child': { borderTop: 'none', paddingTop: 0 },
    '& button': { alignSelf: 'flex-start', marginTop: 12 },
  },
  question: {
    margin: 0,
    fontSize: text.body,
    fontWeight: 600,
    lineHeight: '22px',
    whiteSpace: 'pre-wrap',
  },
  answer: {
    fontSize: text.body,
    overflowWrap: 'anywhere',
  },
  meta: {
    margin: 0,
    color: theme.palette.text.secondary,
    fontSize: text.meta,
    lineHeight: '18px',
    overflowWrap: 'anywhere',
    '& summary': { cursor: 'pointer' },
  },
  files: {
    margin: '6px 0 0',
    paddingLeft: 18,
  },
  actions: {
    display: 'flex',
    gap: 8,
    '& button': { textTransform: 'none' },
  },
  visuallyHidden: {
    position: 'absolute',
    width: 1,
    height: 1,
    overflow: 'hidden',
    clip: 'rect(0 0 0 0)',
    whiteSpace: 'nowrap',
  },
}));
